/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Two_Fa_Enter_Setup_KeyInputs */

const en_two_fa_enter_setup_key = /** @type {(inputs: Two_Fa_Enter_Setup_KeyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Or enter this setup key in your authenticator app:`)
};

const nl_two_fa_enter_setup_key = /** @type {(inputs: Two_Fa_Enter_Setup_KeyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Of voer deze setup-sleutel in je authenticator-app in:`)
};

/**
* | output |
* | --- |
* | "Or enter this setup key in your authenticator app:" |
*
* @param {Two_Fa_Enter_Setup_KeyInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const two_fa_enter_setup_key = /** @type {((inputs?: Two_Fa_Enter_Setup_KeyInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Two_Fa_Enter_Setup_KeyInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_two_fa_enter_setup_key(inputs)
	return en_two_fa_enter_setup_key(inputs)
});